import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Pin } from 'src/app/models/Pin';
import { PinGroup } from 'src/app/models/PinGroup';
import { User } from 'src/app/models/User';
import { PinService } from 'src/app/services/pin.service';
import { ShareDataService } from 'src/app/services/shareData.service';
import { CONSTANTES } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-pin-result',
  templateUrl: './pin-result.component.html',
  styleUrls: ['./pin-result.component.scss']
})
export class PinResultComponent implements OnInit {

  imagesUrl = CONSTANTES.pasadoresUrl;
  tableTitle: string[] = ["Tipo de Condecoración", "Condecoraciones Seleccionadas", "Número Pasadores"];
  types: string[] = ["Condecoraciones civiles españolas de las Ordenes y recompensas civiles que se correspondan a otras categorias o grados inferiores a Gran Cruz",
    'Condecoraciones Militares', 'Condecoraciones militares y civiles extranjeras', 'Grandes Cruces de otras Ordenes Españolas', 'Medallas conmemorativas',
    'Medallas de campañas', 'Medallas de organizaciones internacionales'];
  pines: Pin[] = [];
  subscription: Subscription;
  typePinesTitle: Map<string, number> = new Map();
  allPinesTitle: Map<string, number> = new Map();

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private shareDataService: ShareDataService,
    private pinService: PinService
  ) { }

  ngOnInit() {
    this.spinner.show()
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }
    this.subscription = this.shareDataService.valuePines.subscribe(pines => this.pines = pines)
    this.updateTable()
  }

  updateTable() {
    this.types.forEach(titulo => {
      let pinesTitulo = this.pines.filter(pin => pin.type === titulo)
      this.allPinesTitle.set(titulo, pinesTitulo.length);
      const item = [...new Set(pinesTitulo)];
      this.typePinesTitle.set(titulo, item.length)
    })
    this.spinner.hide()
  }

  ngOnDestroy() {
    this.shareDataService.changePines(null);
    this.subscription.unsubscribe();
  }

  cancel() {
    this.shareDataService.changePines(null);
    this.router.navigate(['pin-generator']);
  }

  confirm() {
   
    this.spinner.show();
    let group = new PinGroup();
    group.creationDate = new Date();
    group.user = new User();
    group.user.nid = localStorage.getItem('nid');
    group.pins = this.pines;
    
    this.pinService.savePinGroup(group).subscribe(
      data => {
        this.toastr.success("CONJUNTO DE PASADORES GUARDADO")
        this.shareDataService.changePines(null);
        this.router.navigate(['my-pines']);
        this.spinner.hide();
      }, error => {
        this.toastr.error("ERROR AL GUARDAR EL CONJUNTO DE PASADORES");
        //this.shareDataService.changePines(null);
       // this.router.navigate(['pin-generator']);
       this.spinner.hide();
      }
    )

   
  }

}
